// @ts-check

/**
 * @returns {boolean} is user authenticated
 */
export function isAuthenticated() {
  return Boolean(localStorage.getItem('Authorization'));
}
